<template>
  <a
    :class="view.isEnabled ? '' : 'disabled'"
    class="button button--black appleSignIn shortform-sign-up__button"
    @click="login"
  >
    <img
      class="button__img"
      src="@/assets.app/images/sign-up-apple-white.svg"
      alt=""
    />
    <!-- Note: for Facebook and Google we have {{ title }} here to make
    it Sign In with Facebook or Log In with Facebook depending on the page.
    Also, the second `span d-md-none` is to make a shorter variant,
    just "Facebook", no prompt on tablet screen.

    We don't do this for Apple button as they have strict requirements on
    what the title text could be:

    > Titles. Use only Sign in with Apple, Sign up with Apple,
    > or Continue with Apple.

    See also: https://developer.apple.com/design/human-interface-guidelines/sign-in-with-apple/overview/buttons/
    -->
    <span class="button__text d-none d-md-inline">{{ title }} Apple</span>
    <span class="button__text d-md-none">{{ title }} Apple</span>
  </a>
</template>

<script setup lang="ts">
import { AppleNativeAuthView } from '@/models/auth/apple.native'

const props = defineProps<{
  view: AppleNativeAuthView
  title: string
}>()

async function login(): Promise<void> {
  await props.view.start()
}
</script>
